import { ContextProviders } from 'components/_stores/_context-providers'
import { LoadInitialData } from 'components/_stores/_load-initial-data'
import { Footer } from 'components/layout/footer'
import { Header } from 'components/layout/header'
import { DefaultSeo } from 'next-seo'
import { AppProps } from 'next/app'
import { useRouter } from 'next/router'
import { FC, PropsWithChildren, useEffect } from 'react'
import { FloatingWhatsApp } from 'react-floating-whatsapp'
import 'styles/tailwind.css'

const Loaders: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ContextProviders>
      <LoadInitialData>{children}</LoadInitialData>
    </ContextProviders>
  )
}
const title = 'Karan Gandhi - Freelance Web Developer | Entrepreneur'
const description =
  'Passionate self-taught Full-stack Developer and Entrepreneur based in India. Specializing in innovative solutions and web development. Explore my portfolio to see how I can help you succeed.'

const App = ({ pageProps, Component }: AppProps) => {
  const router = useRouter()

  useEffect(() => {
    if (window) {
      if (process.env.NODE_ENV !== 'development') {
        console.log(
          '%c' +
            'HEY YOU! I see you sneaking in our code. We will be glad to have some good developers join us. ' +
            'Interested? Just drop us your resume at info@syntaxwork.com !',
          'background: rgb(0,0,0);color: #fafafa;font-size: 24px;font-weight: bold;padding: 25px 10px;text-align: center;text-shadow: 2px 2px 0 rgba(45, 45, 45);'
        )
      }
    }
  }, [])

  return (
    <>
      <DefaultSeo
        description={description}
        canonical={`https://karan0805.vercel.app/${router.pathname}`}
        openGraph={{
          type: 'website',
          locale: 'en_IE',
          url: 'https://karan0805.vercel.app',
          site_name: 'Karan0805',
          title,
          description,
          images: [
            {
              url: 'https://karan0805.vercel.app/images/sharing-image.jpg',
              alt: title,
              width: 1200,
              height: 630,
            },
          ],
        }}
        title={title}
        twitter={{
          handle: '@Karan_0805',
          site: '@Karan_0805',
          cardType: 'summary_large_image',
        }}
      />
      <Loaders>
        <Header />
        <main className="min-h-screen print:!mx-auto print:!w-[1024px]">
          <Component {...pageProps} />
          <FloatingWhatsApp
            className="text-black print:!hidden"
            phoneNumber="+919909966560"
            allowClickAway
            notificationSound={true}
            accountName="Karan Gandhi"
            chatMessage={'Hello there! 🤝 \nHow can I help you?'}
            avatar="/profile.jpeg"
          />
        </main>
        <Footer />
      </Loaders>
    </>
  )
}

export default App
